const toggleTab = (header) => {
	const tab = header.closest('.collapsible-tab');
	const content = document.getElementById(header.getAttribute('aria-controls'));
	const isOpen = tab.classList.toggle('is-open');

	header.setAttribute('aria-expanded', isOpen ? 'true' : 'false');

	if (!content) return;

	if (isOpen) {
		content.removeAttribute('aria-hidden');
		content.removeAttribute('inert');
	} else {
		content.setAttribute('aria-hidden', 'true');
		content.setAttribute('inert', '');
	}
};

document.querySelectorAll('.collapsible-tab--header').forEach((header) => {
	header.addEventListener('click', () => toggleTab(header));
});
